export default __webpack_public_path__ + "static/media/single-right-border-right.55166b7a.svg";